import { Alert } from 'components/ui'


const alertTemplate = ({ style, options, message, close }) => {


    return (

        <div>
            {options.type === 'info' ?
                <Alert type="info" title="Information" showIcon>
                    {message}
                </Alert> :
                options.type === 'success' ?
                    <Alert type="danger" title="Success" showIcon>
                        {message}
                    </Alert> :

                    <Alert type="danger" title="Error" showIcon>
                        {message}
                    </Alert>
            }
        </div>


    )

}

export default alertTemplate;